import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
    providedIn: 'root'
})
export class TranslateHelper {
    constructor(private translate: TranslateService) {
        this.localize = this.localize.bind(this);
        this.getTranslation = this.getTranslation.bind(this);
        this.getTranslationCB = this.getTranslationCB.bind(this);
    }

    public localize(obj: { [x: string]: any; en: any; }) {
        if (!obj) return '';
        const currLang = this.translate.currentLang || 'en';
        return obj[currLang] ?? obj.en ?? '';
    }

    public getTranslation(name): string {
        let translation;
        this.translate.get(name).subscribe(value => (translation = value))
        return translation;
    }

    public getTranslationCB(name: string, func: (value: string) => void) {
        this.translate.get(name).subscribe(func);
    }

}
